import React from 'react';

import { useIntl } from 'react-intl';

import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { IconButton } from '@atlaskit/button/new';
import DislikeIcon from '@atlaskit/icon/core/thumbs-down';
import LikeIcon from '@atlaskit/icon/core/thumbs-up';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const getIconComponent = (isDislike: boolean, isSelected: boolean) => {
	const Icon = isDislike ? DislikeIcon : LikeIcon;
	const iconColor = isSelected ? token('color.icon.accent.blue') : token('color.icon.subtlest');
	return () => <Icon label="" color={iconColor} />;
};

type ThumbsButtonProps = {
	onClick: (event: UIAnalyticsEvent) => void;
	isDislike?: boolean;
	isSelected?: boolean;
	spacing?: 'compact' | 'default';
	testId?: string;
};

export const LikeButton = ({
	onClick,
	isDislike,
	isSelected,
	spacing = 'compact',
	testId,
}: ThumbsButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<IconButton
			isTooltipDisabled={false}
			label={
				isDislike
					? formatMessage(messages.badResponseLabel)
					: formatMessage(messages.goodResponseLabel)
			}
			type="button"
			testId={testId}
			onClick={(_, event: UIAnalyticsEvent) => onClick(event)}
			icon={getIconComponent(isDislike ?? false, !!isSelected)}
			appearance="subtle"
			spacing={spacing}
			shape="default"
			isSelected={!!isSelected}
		/>
	);
};
